import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom'; // Add Link

function InMemoriam() {
  const { playerId } = useParams();
  const [dogs, setDogs] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch(`${API_BASE_URL}/in-memoriam/${playerId}`)
      .then(res => {
        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
        return res.json();
      })
      .then(data => {
        console.log('In Memoriam data:', data);
        setDogs(data || []);
      })
      .catch(err => setMessage('Error: ' + err.message));
  }, [playerId]);

  return (
    <div style={{ padding: '20px' }}>
      <h1>In Memoriam</h1>
      {message && <p>{message}</p>}
      {dogs.length > 0 ? (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {dogs.map(dog => (
            <li key={dog._id} style={{ marginBottom: '20px' }}>
              <Link to={`/dog/${dog.dogId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <strong>{dog.registeredName}</strong> ({dog.breed})
              </Link><br />
              Kennel: {dog.kennelId?.kennelName || 'N/A'}<br />
              <Link to={`/dog/${dog.dogId}`}>
                <img src={dog.artUrl || 'https://via.placeholder.com/150'} alt={dog.registeredName} style={{ maxWidth: '150px' }} />
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p>No deceased dogs yet.</p>
      )}
    </div>
  );
}

export default InMemoriam;